// Shared subtle styles for CRUD pages (create/edit/delete buttons and cards)

export const crudColors = {
  primary: '#1C85FC',
  primarySoft: '#1C85FC',
  neutralText: '#475569',
  neutralBorder: '#cbd5e1',
  danger: '#dc2626',
  cardBorder: '#e5e7eb',
  cardAccent: '#1C85FC',
};

export const crudStyles = {
  containerCard: {
    background: 'white',
    borderRadius: '15px',
    border: `1px solid ${crudColors.cardBorder}`,
    borderLeft: `4px solid ${crudColors.cardAccent}`,
    boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
  },
  // Use className-based styles from crudStyles.css for hover/active effects
  buttonClass: 'crud-btn',
  buttonPrimaryClass: 'crud-btn crud-btn--primary',
  buttonPrimarySoftClass: 'crud-btn crud-btn--primary-soft',
  buttonNeutralClass: 'crud-btn crud-btn--neutral',
  buttonDangerClass: 'crud-btn crud-btn--danger',
};

export default crudStyles;


